import groupBy from 'lodash-es/groupBy';
import { CATEGORY_BRANDS, CATEGORY_SALE } from '../bff-api/categories/model/category';
import type { Categories, Category } from '../bff-api/categories/model/category';
import type { Dictionary } from '../types/helpers';

export const isBrandsCategory = ({ displayName }: Category): boolean =>
    displayName.toLowerCase() === CATEGORY_BRANDS;

export const isSaleCategory = ({ displayName }: Category): boolean =>
    displayName.toLowerCase() === CATEGORY_SALE;

export const toCategoriesDictionary = (category?: Category | null): Dictionary<Categories> =>
    category
        ? groupBy(
              category.subCategories.filter((cat) => !isBrandsCategory(cat)),
              (cat) => cat.megaNavColumn?.charAt(0),
          )
        : {};
